import { IUpdateDiarioObraEfetivoUseCase } from "../../../presentation/useCases/update/update_diario_obras_efetivo_use_case";
import { IDiarioObraRepository } from "../../repositories/diario_obra_repository";

export class UpdateDiarioObraEfetivoUseCase implements IUpdateDiarioObraEfetivoUseCase {
  constructor(private readonly repository: IDiarioObraRepository) {}

  async updateDiarioObraEfetivo(
    IdDiarioObras: number,
    IdDiarioObrasEfetivo: number,
    IdCargo: number | null,
    Tipo: number | null,
    Categoria: number | null,
    Quantidade: number | null,
    Descricao: string | null,
    IdFornecedor: number | null,
    IdsFuncionarios: number[] | null,
  ): Promise<void> {
    await this.repository.updateDiarioObraEfetivo(
      IdDiarioObras,
      IdDiarioObrasEfetivo,
      IdCargo,
      Tipo,
      Categoria,
      Quantidade,
      Descricao,
      IdFornecedor,
      IdsFuncionarios,
    );
  }
}
